export interface MangaCategory {
  id: string;
  name: string;
  icon: string;
  description: string;
}

export interface MangaArticle {
  id: string;
  categoryId: string;
  title: string;
  excerpt: string;
  content: string[];
  cover: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  featured?: boolean;
  updateInfo?: string;
}

export const categories: MangaCategory[] = [
  {
    id: "latest",
    name: "最新话",
    icon: "ri-flashlight-line",
    description: "第一时间掌握各大连载作品的最新一话更新动态，追更快人一步。",
  },
  {
    id: "serializing",
    name: "连载中",
    icon: "ri-ink-bottle-line",
    description: "正在火热连载中的日漫作品进度汇总，随时了解当前话数与剧情走向。",
  },
  {
    id: "completed",
    name: "已完结",
    icon: "ri-book-3-line",
    description: "经典日漫完结纪念与回顾，重温那些陪伴我们成长的故事。",
  },
  {
    id: "anime",
    name: "动画化",
    icon: "ri-movie-2-line",
    description: "漫画动画化改编的最新情报，从原作到荧幕的精彩升级。",
  },
  {
    id: "news",
    name: "情报剧透",
    icon: "ri-spy-line",
    description: "日漫情报与剧透速递，抢先了解未来的剧情发展，满足你的好奇心。",
  },
  {
    id: "hiatus",
    name: "休刊公告",
    icon: "ri-calendar-check-line",
    description: "各大作品的休刊与复刊提醒，合理安排你的追更节奏。",
  },
];

export const articles: MangaArticle[] = [
  {
    id: "a-latest-001",
    categoryId: "latest",
    title: "《海贼王》最新话：路飞五档觉醒再临，和之国决战迎来关键转折",
    excerpt:
      "本周《海贼王》最新话震撼来袭，路飞再次开启五档形态，与宿敌的终极对决进入白热化阶段，剧情走向迎来重大转折。",
    content: [
      "本周《海贼王》最新话正式公开，整话围绕和之国决战的关键节点展开，路飞在绝境中再度点燃五档尼卡形态，战斗场面与情绪张力都拉满。作者尾田荣一郎在本话中埋下了多处伏笔，为后续剧情走向留下了巨大想象空间。",
      "本话开篇承接上一话的紧张局势，草帽一伙全员集结，为最终的胜利做最后准备。路飞与凯多的对决成为全话焦点，五档形态下的夸张战斗表现力再次刷新读者的认知，橡胶果实的真名与尼卡传说的关联也在本话中得到进一步揭示。",
      "值得注意的是，本话还穿插了多条支线剧情，包括和之国的民众觉醒、基德与罗的动向，以及大秘宝（One Piece）相关线索的暗示。作者用多线并进的手法，将宏大世界观逐渐收拢到最终决战的核心。",
      "对于一直追更的老读者来说，这一话的情绪铺垫和伏笔回收相当出色。无论是分镜设计还是对白节奏，都展现了顶级连载作品的成熟功力。建议结合前几话一起回顾，能更好地体会剧情的连贯性。",
      "下一话预计将于下周四更新，届时决战将进入全新的阶段。请继续关注本站，我们会在第一时间带来最新话的完整解读与情报汇总。",
    ],
    cover: "https://readdy.ai/api/search-image?query=epic%20anime%20pirate%20battle%20scene%20with%20hero%20in%20super%20form%2C%20dynamic%20ocean%20waves%20and%20storm%20clouds%2C%20vivid%20red%20and%20orange%20energy%2C%20stylized%20manga%20illustration%2C%20high%20contrast%2C%20cinematic%20composition&width=800&height=520&seq=cover-one-piece&orientation=landscape",
    author: "小海",
    date: "2026-08-14",
    views: 128400,
    tags: ["海贼王", "五档", "和之国", "最新话"],
    featured: true,
    updateInfo: "第1120话 · 更新于 3 小时前",
  },
  {
    id: "a-latest-002",
    categoryId: "latest",
    title: "《咒术回战》最新话：宿傩战局升级，伏黑惠觉醒新能力",
    excerpt:
      "《咒术回战》最新话中，宿傩与咒术师们的战局再度升级，伏黑惠在绝境中觉醒全新能力，为整场对决增添变数。",
    content: [
      "《咒术回战》最新话公开后引发热议，本话将宿傩战的紧张感推向新高度。随着战斗进入白热化，伏黑惠在生死关头觉醒出令人意想不到的新能力，成为扭转战局的关键变量。",
      "作者芥见下下在本话的作画与分镜上倾注了大量心血，战斗的节奏把控精准，每一格都充满压迫感。宿傩的强大与咒术师们的顽强形成鲜明对比，让读者在窒息感中体会到热血与绝望交织的复杂情绪。",
      "本话还揭示了更多关于『领域展开』与咒力本质的设定细节，为后续的大决战埋下伏笔。多角色交织的战斗编排显示出作者对群像剧的驾驭能力，每个角色都有自己的高光时刻。",
      "对于新读者而言，本话信息量较大，建议从之前的篇章开始补起，以便更好地理解人物关系与力量体系。本站也会持续跟进该作品的每周更新。",
    ],
    cover: "https://readdy.ai/api/search-image?query=dark%20supernatural%20anime%20battle%20with%20glowing%20cursed%20energy%20and%20shadowy%20figure%2C%20moody%20red%20and%20black%20tones%2C%20stylized%20manga%20artwork%2C%20dramatic%20lighting%2C%20high%20contrast%20composition&width=800&height=520&seq=cover-jujutsu&orientation=landscape",
    author: "咒术酱",
    date: "2026-08-13",
    views: 96400,
    tags: ["咒术回战", "宿傩", "伏黑惠", "领域展开"],
    featured: true,
    updateInfo: "第265话 · 更新于 1 天前",
  },
  {
    id: "a-latest-003",
    categoryId: "latest",
    title: "《间谍过家家》最新话：黄昏任务陷入危机，阿尼亚再立大功",
    excerpt:
      "《间谍过家家》最新话中，黄昏的秘密任务遭遇意外危机，关键时刻阿尼亚的神奇能力再次成为扭转局面的关键。",
    content: [
      "《间谍过家家》最新话继续保持着轻松与紧张并存的独特氛围。本话中，黄昏在执行秘密任务时遭遇预料之外的变故，整个计划面临失败的风险，气氛一度紧张到极点。",
      "作为全作的人气担当，阿尼亚在本话再次展现了她读心能力的价值。她用童真又机灵的方式在大人眼中“捣乱”，却在无意间化解了重大危机，让人忍俊不禁的同时又为这个家庭的温情而动容。",
      "作者远藤达哉在本话对家庭的刻画依旧细腻，任务线与温馨日常交织推进，让读者在欢笑与紧张之间反复横跳，充分体现了这部作品的独特魅力。",
      "本话结束后，下一话将开启新的任务篇章，更多关于黄昏与约尔身份的悬念有望得到进一步展开，值得期待。",
    ],
    cover: "https://readdy.ai/api/search-image?query=charming%20cute%20anime%20family%20spy%20comedy%20scene%20with%20child%20character%2C%20colorful%20and%20playful%2C%20warm%20lighting%2C%20stylized%20manga%20illustration%2C%20energetic%20composition&width=800&height=520&seq=cover-spy&orientation=landscape",
    author: "黄昏事务所",
    date: "2026-08-12",
    views: 85200,
    tags: ["间谍过家家", "阿尼亚", "黄昏", "最新话"],
    updateInfo: "第103话 · 更新于 2 天前",
  },
  {
    id: "a-serial-001",
    categoryId: "serializing",
    title: "《进击的巨人》终章长篇盘点：连载进度与最终剧情全梳理",
    excerpt:
      "作为现象级作品，《进击的巨人》的连载进度一直是读者关注的焦点。本文为你完整梳理其终章剧情脉络与连载情况。",
    content: [
      "《进击的巨人》以其宏大而沉重的世界观，成为一代读者的青春记忆。本文将从连载进度、剧情脉络与核心设定三个维度，为你带来一次完整的回顾与梳理。",
      "作品以人类对抗巨人的残酷世界为起点，逐步揭示出背后层层递进的政治隐喻与人性拷问。谏山创用极其大胆的笔触，将一个关于自由、背叛与救赎的故事推向极致。",
      "在连载后期，作品的节奏明显加快，多条伏笔集中回收，剧情在震撼之余也引发了广泛讨论。无论是支持还是反对作品结局，都无法否认这部作品在当代漫画史上的重要地位。",
      "本文适合新老读者共同阅读，帮助你快速建立起对整个故事的完整认知，也可以作为重温经典时的参考指南。",
    ],
    cover: "https://readdy.ai/api/search-image?query=towering%20giant%20humanoid%20figure%20against%20dramatic%20sky%2C%20epic%20anime%20post-apocalyptic%20scene%2C%20somber%20orange%20and%20grey%20tones%2C%20stylized%20manga%20artwork%2C%20cinematic%20and%20atmospheric&width=800&height=520&seq=cover-attack&orientation=landscape",
    author: "自由之翼",
    date: "2026-08-11",
    views: 110300,
    tags: ["进击的巨人", "终章", "连载", "盘点"],
    featured: true,
    updateInfo: "共 139 话 · 已完结",
  },
  {
    id: "a-serial-002",
    categoryId: "serializing",
    title: "《葬送的芙莉莲》连载进展：勇者之旅后的漫长岁月与冒险重生",
    excerpt:
      "《葬送的芙莉莲》以“冒险结束后”的全新视角讲述故事，独特的叙事结构让它成为近年的现象级连载之一。",
    content: [
      "《葬送的芙莉莲》用一种罕见的叙事角度切入：魔王被打倒之后，故事才真正开始。作为长寿精灵的芙莉莲，在漫长的岁月中重新认识那些短暂而珍贵的人际羁绊，让整部作品充满温柔与哲思。",
      "作品以单元剧与主线并行的方式展开，每一段旅程都藏着对生命、时间与传承的深刻思考。作者山田钟人细腻的笔触与阿部司精美的作画相得益彰，营造出独一无二的阅读体验。",
      "在最新的连载中，芙莉莲一行继续着收集魔导书的旅程，与过去伙伴的回忆不时浮现，为故事增添了厚重的层次感。作品在温馨与伤感之间找到了绝佳平衡。",
      "该作品已被成功动画化并广受好评，连载仍在稳步推进，新篇章的剧情走向备受读者期待，本站将持续关注其更新动态。",
    ],
    cover: "https://readdy.ai/api/search-image?query=peaceful%20fantasy%20anime%20scene%20with%20long%20white%20haired%20elf%20mage%20in%20lush%20meadow%2C%20soft%20golden%20light%2C%20gentle%20atmosphere%2C%20stylized%20manga%20artwork%2C%20warm%20and%20dreamy%20composition&width=800&height=520&seq=cover-frieren&orientation=landscape",
    author: "芙莉莲观察站",
    date: "2026-08-10",
    views: 98300,
    tags: ["葬送的芙莉莲", "连载", "冒险", "动画化"],
    updateInfo: "第140话 · 更新于 3 天前",
  },
  {
    id: "a-serial-003",
    categoryId: "serializing",
    title: "《电锯人》连载再启：第二部剧情全面升级，恶魔与人类的纠葛再起",
    excerpt:
      "藤本树的《电锯人》在第二部连载中全面升级，更复杂的势力博弈与更疯狂的想象力让这部作品持续霸榜。",
    content: [
      "《电锯人》以其天马行空的情节与残酷又浪漫的笔触，成为当代最具话题性的连载作品之一。第二部开启后，故事舞台从第一部转向校园与都市，主角更换为少女三鹰朝，带来了全新的叙事视角。",
      "作者藤本树延续了他标志性的“脑洞大开”风格，将恶魔、契约与人类情感的复杂关系演绎得淋漓尽致。第二部在保留血腥与荒诞的同时，加入了更多关于成长与选择的探讨。",
      "在最近的连载中，电锯人与正义恶魔之间的对抗持续升温，多条伏笔逐渐收拢。作品对“何为正确”的追问贯穿始终，让读者在猎奇之余也收获深刻的思考。",
      "对于喜欢先锋叙事的读者而言，《电锯人》无疑是不容错过的佳作。本站会持续跟进其双周更新的节奏，第一时间为你带来最新情报。",
    ],
    cover: "https://readdy.ai/api/search-image?query=surreal%20dark%20anime%20scene%20with%20chainsaw%20monster%20and%20blood%20splatter%2C%20chaotic%20red%20and%20black%2C%20grindhouse%20style%2C%20stylized%20manga%20artwork%2C%20raw%20and%20energetic%20composition&width=800&height=520&seq=cover-chainsaw&orientation=landscape",
    author: "恶魔契约",
    date: "2026-08-09",
    views: 87400,
    tags: ["电锯人", "藤本树", "连载", "第二部"],
    updateInfo: "第182话 · 更新于 4 天前",
  },
  {
    id: "a-completed-001",
    categoryId: "completed",
    title: "《鬼灭之刃》完结纪念：从爆红到封神的完整历程回顾",
    excerpt:
      "《鬼灭之刃》以惊人的速度成长为全球现象级 IP，本文带你回顾这部作品从连载到完结的传奇历程与深远影响。",
    content: [
      "《鬼灭之刃》的崛起堪称当代漫画史的神话。这部作品在连载初期并不被看好，却凭借扎实的情感内核与惊艳的动画改编，在短短数年内成为全球范围内无可争议的现象级 IP。",
      "故事围绕少年炭治郎为拯救变成鬼的妹妹祢豆子而展开的旅程，将“家人”与“羁绊”这两个朴素主题贯穿始终。吾峠呼世晴用克制而深情的笔触，塑造了无数令人难忘的角色。",
      "作品的完结篇以其感人的结局画上圆满句号，炭治郎一行的旅程在泪水中迎来新生。作者对每个角色的命运安排都饱含温度，让读者在告别中收获治愈。",
      "《鬼灭之刃》的成功也为后续无数作品提供了范本，证明了情感力量永远是一部作品最核心的竞争力。完结并不代表结束，这个温暖的故事将永远留在读者心中。",
    ],
    cover: "https://readdy.ai/api/search-image?query=heroic%20anime%20samurai%20boy%20with%20sword%20and%20flame%20effects%2C%20japanese%20demon%20slayer%20aesthetic%2C%20vivid%20red%20and%20teal%2C%20stylized%20manga%20artwork%2C%20dramatic%20and%20epic%20composition&width=800&height=520&seq=cover-demon&orientation=landscape",
    author: "日轮刀",
    date: "2026-08-08",
    views: 135600,
    tags: ["鬼灭之刃", "完结", "纪念", "炭治郎"],
    featured: true,
    updateInfo: "共 205 话 · 已完结",
  },
  {
    id: "a-completed-002",
    categoryId: "completed",
    title: "《火影忍者》完结十周年：木叶忍者们的故事与传承",
    excerpt:
      "《火影忍者》完结多年，鸣人从吊车尾到火影的成长故事依旧激励着一代人。值此纪念之际，一起重温这段传奇。",
    content: [
      "从1999年连载开启到2014年正式完结，《火影忍者》陪伴了无数读者走过青春岁月。鸣人从一个被全村排挤的吊车尾，凭借永不放弃的忍道精神，最终成为木叶村的第七代火影，这个成长故事本身就是一部热血史诗。",
      "岸本齐史在作品中构建了庞大而完整的忍者世界体系，查克拉、忍术、血继限界等设定极具想象力。作品对“羁绊”“同伴”与“和平”的探讨，让它在热血之外拥有了更深刻的厚度。",
      "完结多年后，鸣人、佐助、小樱等角色的形象依旧深入人心，后续作品《博人传》也延续了这个火影世界的传奇。木叶忍者们的故事，已经成为一代读者共同的青春记忆。",
      "值此完结十周年之际，我们希望通过这篇回顾，与所有老读者一起重温那段关于坚持与梦想的岁月。木叶之火，生生不息。",
    ],
    cover: "https://readdy.ai/api/search-image?query=energetic%20anime%20ninja%20with%20spiky%20blond%20hair%20in%20orange%20outfit%20leaping%20through%20village%2C%20warm%20orange%20sunset%2C%20stylized%20manga%20artwork%2C%20dynamic%20and%20nostalgic%20composition&width=800&height=520&seq=cover-naruto&orientation=landscape",
    author: "木叶传",
    date: "2026-08-06",
    views: 142800,
    tags: ["火影忍者", "完结", "鸣人", "十周年"],
    updateInfo: "共 700 话 · 已完结",
  },
  {
    id: "a-anime-001",
    categoryId: "anime",
    title: "《咒术回战》剧场版动画企划公开，制作阵容与上映档期前瞻",
    excerpt:
      "《咒术回战》全新剧场版动画企划正式公开，官方公布了核心制作阵容，并预告了即将公布的上映档期信息。",
    content: [
      "备受期待的《咒术回战》剧场版动画企划终于正式公开，消息一出便引爆社交平台。官方同步放出了概念视觉图与核心制作阵容，让无数粉丝为之沸腾。",
      "据悉，本次剧场版将由原动画核心班底倾力打造，MAPPA 再次扛起制作大旗。从已公开的视觉图来看，作画质量依旧保持着系列一贯的高水准，战斗场景的张力令人期待。",
      "关于剧场版的具体剧情内容，官方目前仍保持神秘，仅透露将围绕原作中的关键篇章展开。结合漫画进度与粉丝呼声，多段人气剧情的改编可能性都在讨论之中。",
      "官方表示，详细的上映档期与首支预告片将于近期陆续公布。本站将持续跟进最新消息，第一时间为你带来剧场版的全部动态。",
    ],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20anime%20movie%20poster%20scene%20with%20young%20sorcerer%20and%20glowing%20energy%20vortex%2C%20dark%20blue%20night%20mood%2C%20stylized%20manga%20artwork%2C%20dramatic%20lighting%2C%20epic%20composition&width=800&height=520&seq=cover-jjk-movie&orientation=landscape",
    author: "咒术酱",
    date: "2026-08-05",
    views: 76300,
    tags: ["咒术回战", "剧场版", "动画", "MAPPA"],
    featured: true,
    updateInfo: "情报公开于 2 天前",
  },
  {
    id: "a-anime-002",
    categoryId: "anime",
    title: "《葬送的芙莉莲》第二季动画制作决定，预计明年春季开播",
    excerpt:
      "官方正式宣布《葬送的芙莉莲》第二季动画制作决定，制作团队原班人马回归，预计明年春季与观众见面。",
    content: [
      "在一众粉丝的翘首以盼中，官方终于正式宣布《葬送的芙莉莲》第二季动画制作决定。这一消息随即登上多个社交平台热搜，足见作品的人气之高。",
      "第二季将延续第一季的核心制作团队，Madhouse 再次操刀，确保作品一贯的细腻作画与治愈氛围得以延续。从已公布的设定图来看，芙莉莲一行的新旅程场景唯美而动人。",
      "第二季的剧情预计将覆盖原作中旅途更深处的内容，芙莉莲在回忆与现实交织中逐渐理解人类情感的线索将持续深化。原作扎实的剧情储备为动画质量提供了坚实保障。",
      "官方初步规划第二季将于明年春季开播，具体集数与播出平台将在后续公布。本站会第一时间同步开播时间，帮助大家不错过这部治愈佳作。",
    ],
    cover: "https://readdy.ai/api/search-image?query=whimsical%20anime%20journey%20scene%20with%20elf%20mage%20and%20companions%20walking%20through%20autumn%20forest%2C%20golden%20leaves%2C%20soft%20magical%20glow%2C%20stylized%20manga%20artwork%2C%20warm%20and%20serene%20composition&width=800&height=520&seq=cover-frieren2&orientation=landscape",
    author: "芙莉莲观察站",
    date: "2026-08-04",
    views: 68900,
    tags: ["葬送的芙莉莲", "第二季", "动画", "Madhouse"],
    updateInfo: "制作决定 · 明春开播",
  },
  {
    id: "a-news-001",
    categoryId: "news",
    title: "本周日漫情报汇总：各大连载新刊发售与剧情前瞻盘点",
    excerpt:
      "本期情报汇总带你快速掌握本周日漫圈的重磅消息：多部连载新刊发售、人气作品剧情前瞻，以及即将公布的重要企划。",
    content: [
      "本期「日漫情报汇总」为你盘点本周漫画圈不容错过的重磅消息，从新刊发售到剧情前瞻，一篇看尽本周动态。",
      "本周多部人气连载作品的新刊陆续发售，其中《海贼王》单行本的最新卷延续了卷末彩蛋的传统，暗藏大量细节线索；《咒术回战》的新刊也收录了此前仅在杂志刊载的番外内容，收藏价值颇高。",
      "剧情前瞻方面，多部作品的下一话安排也陆续揭晓。官方公布的标题与配图暗示了即将到来的关键剧情节点，引发粉丝热烈猜测。本站将在第一时间更新完整解读。",
      "此外，本周还传出多项重要企划消息，包括人气作品的官方周边、联动活动等，详情请关注本站后续专题报道。",
    ],
    cover: "https://readdy.ai/api/search-image?query=stack%20of%20colorful%20manga%20comic%20books%20with%20dynamic%20action%20artwork%20on%20covers%2C%20vibrant%20and%20energetic%2C%20warm%20studio%20lighting%2C%20stylized%20editorial%20photography%2C%20high%20detail%20composition&width=800&height=520&seq=cover-news&orientation=landscape",
    author: "情报君",
    date: "2026-08-03",
    views: 54200,
    tags: ["情报", "新刊", "汇总", "前瞻"],
    updateInfo: "周报 · 更新于 5 天前",
  },
  {
    id: "a-news-002",
    categoryId: "news",
    title: "剧透预警：《海贼王》未来剧情走向深度解析与伏笔盘点",
    excerpt:
      "基于现有剧情线索与作者惯用笔法，本文为你深度解析《海贼王》未来的剧情走向，并盘点那些早已埋下的重大伏笔。",
    content: [
      "警告：本文涉及大量剧情分析与推测，介意剧透的读者请谨慎阅读。我们将基于已公开的剧情线索，为你解析《海贼王》未来的可能走向。",
      "作为一部连载近三十年的史诗级作品，《海贼王》中埋藏的伏笔数量之多堪称恐怖。从第一话便出现的神秘人物，到贯穿始终的大秘宝之谜，尾田荣一郎用惊人的全局把控力编织了一张巨大的叙事网络。",
      "结合最新的剧情发展，多个关键设定正在被逐步揭晓：恶魔果实的真相、古代兵器、世界政府的秘密，以及路飞身世的完整图景，都在一点点浮出水面。本文为你将这些线索系统串联。",
      "当然，所有分析都只是基于现有信息的合理推测，真正的答案还需等待作者亲自揭晓。希望这篇解析能帮助你更好地享受追更的乐趣。",
    ],
    cover: "https://readdy.ai/api/search-image?query=mysterious%20anime%20pirate%20treasure%20map%20and%20ancient%20scrolls%20with%20glowing%20compass%2C%20adventurous%20warm%20tones%2C%20stylized%20manga%20illustration%2C%20intriguing%20and%20detailed%20composition&width=800&height=520&seq=cover-spoiler&orientation=landscape",
    author: "小海",
    date: "2026-08-01",
    views: 48800,
    tags: ["海贼王", "剧透", "伏笔", "分析"],
    updateInfo: "深度解析 · 更新于 1 周前",
  },
  {
    id: "a-hiatus-001",
    categoryId: "hiatus",
    title: "《电锯人》宣布休刊一周，官方致歉并预告恢复连载时间",
    excerpt:
      "《电锯人》官方宣布本周休刊，为读者带来不便表示歉意，同时确认将于下周恢复连载，敬请期待。",
    content: [
      "《电锯人》官方近日发布公告，宣布本周休刊一期。公告中对休刊给读者带来的不便致以诚挚歉意，并确认作品将于下周恢复正常连载。",
      "据官方说明，本次休刊主要是为了创作质量与作者状态考虑。藤本树一贯以精益求精著称，短暂的休整将有助于带来更加精彩的剧情呈现。",
      "休刊期间，读者可以回顾此前已经发布的章节，或通过本站的往期内容重温经典桥段，为下周的更新做好情绪准备。",
      "本站将第一时间跟进作品的复刊动态，确保你不会错过任何一话的更新信息。请继续关注我们获取最新连载情报。",
    ],
    cover: "https://readdy.ai/api/search-image?query=quiet%20desk%20scene%20with%20closed%20manga%20volume%20and%20coffee%20cup%2C%20soft%20warm%20morning%20light%2C%20peaceful%20atmosphere%2C%20stylized%20editorial%20photography%2C%20calm%20and%20clean%20composition&width=800&height=520&seq=cover-hiatus&orientation=landscape",
    author: "恶魔契约",
    date: "2026-07-30",
    views: 32700,
    tags: ["电锯人", "休刊", "公告", "复刊"],
    updateInfo: "本周休刊 · 下周恢复",
  },
  {
    id: "a-hiatus-002",
    categoryId: "hiatus",
    title: "《海贼王》将连续休刊两周，官方发布长篇致歉信说明原因",
    excerpt:
      "《海贼王》官方宣布因剧情打磨需要连续休刊两周，并发布长篇致歉信向读者说明休刊原因，复刊时间同步公布。",
    content: [
      "《海贼王》官方近日发布重要公告，宣布因最终篇章的剧情打磨需要，作品将连续休刊两周。这一消息在粉丝群体中引发广泛讨论，但也收获了理解与支持。",
      "在长达千余字的长篇致歉信中，编辑部详细说明了本次长时间休刊的原因：随着故事进入最终篇章的高潮阶段，为了保证每一话都能以最佳状态呈现，作者与团队需要更多时间进行打磨。",
      "事实上，这并非《海贼王》首次长时间休刊，此前为创作重要篇章而进行的长休，往往伴随着剧情的重大推进。不少老读者将其视为高质量内容即将到来的前兆。",
      "官方确认作品将于两周后恢复连载，届时预计将带来新的剧情高潮。本站会持续关注复刊动态，第一时间为你更新。",
    ],
    cover: "https://readdy.ai/api/search-image?query=writers%20desk%20with%20ink%20brush%20sketchbook%20and%20storyboard%20pages%2C%20thoughtful%20creative%20process%2C%20warm%20lamp%20light%2C%20stylized%20editorial%20photography%2C%20intimate%20and%20calm%20composition&width=800&height=520&seq=cover-hiatus2&orientation=landscape",
    author: "小海",
    date: "2026-07-28",
    views: 29800,
    tags: ["海贼王", "休刊", "致歉信", "复刊"],
    updateInfo: "连休两周 · 复刊待定",
  },
  {
    id: "a-completed-003",
    categoryId: "completed",
    title: "《排球少年！！》完结回顾：从热血球场到青春谢幕的完整旅程",
    excerpt:
      "《排球少年！！》用一场场精彩的比赛诠释了青春与热血的真谛。本文带你回顾这部体育番经典从连载到完结的完整旅程。",
    content: [
      "《排球少年！！》是体育漫画领域当之无愧的巅峰之作。古馆春一用扎实的排球知识与对人物群像的极致刻画，将一场场排球场上的对决演绎得热血沸腾又细腻动人。",
      "故事以身高劣势却天赋惊人的日向翔阳为核心，讲述他与影山飞雄等伙伴一同成长、冲击全国大赛的青春物语。作品对每个角色的刻画都极其立体，即使是配角也拥有完整的人物弧光。",
      "作品的完结篇以一场震撼人心的大赛决赛收尾，为这群少年的青春画上了圆满的句号。比赛结束的那一刻，无数读者为之动容，那是关于努力、友情与梦想的最好注脚。",
      "《排球少年！！》完结后影响力不减反增，其动画系列同样备受赞誉。对于热爱体育番与热血故事的读者而言，这是一部不容错过的经典之作。",
    ],
    cover: "https://readdy.ai/api/search-image?query=energetic%20anime%20volleyball%20players%20jumping%20for%20a%20spike%20in%20a%20bright%20gymnasium%2C%20dynamic%20action%2C%20orange%20and%20blue%20team%20colors%2C%20stylized%20manga%20artwork%2C%20high%20energy%20composition&width=800&height=520&seq=cover-haikyuu&orientation=landscape",
    author: "乌野高校",
    date: "2026-07-25",
    views: 91700,
    tags: ["排球少年", "完结", "回顾", "体育番"],
    updateInfo: "共 402 话 · 已完结",
  },
  {
    id: "a-anime-003",
    categoryId: "anime",
    title: "《链锯人》第二季动画官宣，制作公司更换引发粉丝热议",
    excerpt:
      "《链锯人》第二季动画正式官宣，但制作公司的更换决定引发粉丝广泛热议，官方回应将延续高规格制作水准。",
    content: [
      "《链锯人》第二季动画的官宣消息无疑是本周动画圈的重磅炸弹，但紧随其后的制作公司更换决定，也为这部作品的前景增添了更多讨论空间。",
      "第一季《链锯人》凭借极具冲击力的作画与独特的美学风格，成为当年的现象级动画。如今第二季换由新的制作团队操刀，粉丝们既期待新团队带来的创新，也担忧风格能否延续。",
      "对此，官方在声明中承诺，第二季将延续系列一贯的高规格制作水准，核心角色设计与世界观的视觉基调将保持一致，请粉丝放心。同时，首支预告片预计将在近期公布。",
      "无论制作团队如何更迭，原作扎实的剧情基础都是作品最坚实的保障。本站将持续关注第二季的制作进展，第一时间为你带来最新消息。",
    ],
    cover: "https://readdy.ai/api/search-image?query=sleek%20anime%20movie%20poster%20with%20youthful%20devil%20hunter%20holding%20chainsaw%2C%20urban%20night%20backdrop%2C%20neon%20accents%2C%20stylized%20manga%20artwork%2C%20cool%20and%20edgy%20composition&width=800&height=520&seq=cover-csm-anime&orientation=landscape",
    author: "恶魔契约",
    date: "2026-07-22",
    views: 67400,
    tags: ["电锯人", "第二季", "动画", "官宣"],
    updateInfo: "动画企划 · 预告待定",
  },
  {
    id: "a-serial-004",
    categoryId: "serializing",
    title: "《蓝色监狱》连载热度持续走高，最新章引爆粉丝讨论",
    excerpt:
      "《蓝色监狱》凭借独特的“自我中心”竞技设定持续走高，最新章节再次引爆粉丝讨论，剧情进入白热化阶段。",
    content: [
      "《蓝色监狱》以“300名前锋中只培养一人”的残酷设定为特色，将足球竞技与心理博弈巧妙结合，近年来热度持续走高，成为体育题材中极具辨识度的存在。",
      "最新章节中，主角洁世一所在的队伍迎来关键一战，比赛过程中的战术博弈与角色心理交锋被刻画得极为精彩，令读者大呼过瘾。",
      "作品的魅力在于它不只是单纯的体育漫画，更是一场关于“利己主义”与“集体协作”的思想碰撞。每一个角色的登场都带来新的看点与惊喜。",
      "随着剧情进入白热化阶段，后续的发展牵动着无数读者的心。本站会持续跟进这部人气作品的每周更新。",
    ],
    cover: "https://readdy.ai/api/search-image?query=intense%20anime%20soccer%20players%20in%20close%20confrontation%20on%20a%20neon%20lit%20pitch%2C%20competitive%20energy%2C%20bold%20shadows%2C%20stylized%20manga%20artwork%2C%20high%20tension%20composition&width=800&height=520&seq=cover-bluelock&orientation=landscape",
    author: "蓝色前锋",
    date: "2026-07-20",
    views: 83600,
    tags: ["蓝色监狱", "连载", "足球", "最新章"],
    updateInfo: "第288话 · 更新于 5 天前",
  },
];